import { Button } from '@mui/material'
import { useState } from 'react';
import VigenereCipherEncryption  from './VigenereCipherEncryption'
import VigenereCipherDecryption  from './VigenereCipherDecryption'
import CustomButton from '../CustomButton';

const VigenereCipherSimulation = () => {
    const [selectedPlain, setSelectedPlain] = useState("")
    const [selectedCipher, setSelectedCipher] = useState("")
    const [selectedKey, setSelectedKey] = useState("")
    const [plainText, setPlainText] = useState("")
    const [cipherText, setCipherText] = useState("")
    const [plainPos, setPlainPos] = useState("")
    const [cipherPos, setCipherPos] = useState("")
    const [key, setKey] = useState("");
    const [clickedSimulate, setClickedSimulate] = useState(false);
    const [isSimulating, setIsSimulating] = useState(false);
    const [table, setTable] = useState([]);

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function getCharIndex(char){
        return ((char.charCodeAt(0) - 65) % 26);
    }

    const generateVigenereTable = () => {
        const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const table = [];

        // Create rows for the table
        for (let i = 0; i < 26; i++) {
            const row = [];
            // Generate each row of the table based on the shift caused by the keyword
            for (let j = 0; j < 26; j++) {
                const index = (j + i) % 26;
                row.push(alphabet.charAt(index));
            }
            table.push(row);
        }
        setTable(table);
    };

    // Function to generate the Vigenere key
    function generateKey(str, k) {
        k = k.toUpperCase();
        let generatedKey = k;
        while (generatedKey.length < str.length) {
            generatedKey += k;
        }
        return generatedKey.substring(0, str.length);
    }

    // Function to encrypt using Vigenere Cipher
    async function encryptByVigenereCipher(str, key) {
        let encryptedText = "";
        setPlainText("")
        setCipherText("")
        setPlainPos("")
        setCipherPos("")

        for (let i = 0; i < str.length; i++) {
            setSelectedPlain(str[i])
            setSelectedKey(key[i]);
            setPlainText(str.substring(0, i + 1))
            let charCode = ((str.charCodeAt(i) - 65 + key.charCodeAt(i) - 65) % 26) + 65;
            encryptedText += String.fromCharCode(charCode);
            setCipherText(encryptedText)
            setSelectedCipher(String.fromCharCode(charCode))
            await sleep(2000).then(() => {

            })
        }
        setIsSimulating(false);
        return encryptedText;
    }

    // Function to decrypt using Vigenere Cipher
    function decryptByVigenereCipher(encryptedText, key) {
        let decryptedText = "";
        for (let i = 0; i < encryptedText.length; i++) {
            let charCode = ((encryptedText.charCodeAt(i) - key.charCodeAt(i) + 26) % 26) + 65;
            decryptedText += String.fromCharCode(charCode);
        }
        return decryptedText;
    }

    function handleSubmit(e) {
        // Prevent the browser from reloading the page
        e.preventDefault();

        if (!isSimulating){
            setIsSimulating(true);
            // Read the form data
            const form = e.target;
            const formData = new FormData(form);

            // You can pass formData as a fetch body directly:
            // fetch('/some-api', { method: form.method, body: formData });

            // Or you can work with it as a plain object:
            const formJson = Object.fromEntries(formData.entries());
            console.log(formJson);
            const pt = formData.get("plaintext").toUpperCase();
            const k = formData.get("key").toUpperCase();
            const generatedKey = generateKey(pt, k);
            setKey(generatedKey);
            setPlainText(pt);
            var res = encryptByVigenereCipher(pt, generatedKey);
            setClickedSimulate(true);
            generateVigenereTable();
            setClickedSimulate(true)

            console.log(res);
        }
        

    }

    return (
        <>
            <form method="post" onSubmit={handleSubmit}>
                <label>
                    Plain Text (only alphabets, without spaces):
                    <input pattern="[a-zA-Z]+" required={true} style={{ textTransform: "uppercase" }} name="plaintext" />
                </label>
                <label>
                    Key (only alphabets, without spaces):
                    <input pattern="[a-zA-Z]+" required={true} style={{ textTransform: "uppercase" }} name="key" />
                </label>
                <CustomButton type="submit" isSimulating={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</CustomButton>
                {/* <Button variant="contained" type='submit' size='medium' disabled={isSimulating}>{isSimulating ? 'Simulating...' : 'Simulate'}</Button> */}
            </form>
            <br />
            {/* <div style={{ display: clickedSimulate ? "block" : "none" }}>
                <p>Ciphertext: {cipherText}</p>
            </div> */}
            <div style={{ display: clickedSimulate ? "block" : "none" }}>
                <VigenereCipherEncryption table={table} selectedRow={getCharIndex(selectedKey)} selectedColumn={getCharIndex(selectedPlain)} cipherText={cipherText}/>
            </div>
            {/* <div style={{ display: clickedSimulate ? "block" : "none" }} >
                <hr />
                <VigenereCipherDecryption plainText={plainText} cipherText={cipherText} plainPos={plainPos} keyword={key} table={table} />
            </div> */}
        </>
    );
}

export default VigenereCipherSimulation;
